var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        attrs: {
          small: "",
          fields: _vm.fields,
          items: _vm.Orders,
          responsive: "sm",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(index)",
            fn: function (data) {
              return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
            },
          },
          {
            key: "cell(orderId)",
            fn: function (data) {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      data.item.salesOrderId !== null
                        ? data.item.salesOrderNumber
                        : data.item.pushOrderNumber
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "cell(orderType)",
            fn: function (data) {
              return [
                data.item.salesOrderId !== null
                  ? _c(
                      "b-badge",
                      {
                        staticClass: "px-1",
                        attrs: { pill: "", variant: "info" },
                      },
                      [_vm._v(" Pulled Order ")]
                    )
                  : _c(
                      "b-badge",
                      {
                        staticClass: "px-1",
                        attrs: { pill: "", variant: "primary" },
                      },
                      [_vm._v(" Pushed Order ")]
                    ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }